
export const ClientStyles = {
    demo:{
        background:{
            backgroundColor:'white',
            height:'100%',
        },
        defaultFont:{
            // we will have to get them to send us their fonts
            fontFamily:'Arial',
            fontWeight:'400',
            fontSize:'15pt',
            letterSpacing:'0',
            fontColor:'#52693a',
        },
        centeredTitleBox:{
            // we will have to get them to send us their fonts
            fontFamily:'Arial',
            fontWeight:'400',
            fontSize:'15pt',
            letterSpacing:'0',
            fontColor:'#52693a',
            display:'flex', 
            alignItems:'centered', 
            justifyContent:'center',
            background:'white', 
            borderRadius:'10px', 
            paddingTop:'40px',
            paddingBottom:'10px',
            opacity:'100%'
        },
        centeredBodyBox:{
            // we will have to get them to send us their fonts
            fontFamily:'Arial',
            fontWeight:'400',
            fontSize:'10pt',
            letterSpacing:'0',
            fontColor:'#52693a',
            display:'flex', 
            alignItems:'centered', 
            justifyContent:'center',
            background:'white', 
            borderRadius:'10px', 
            paddingTop:'40px',
            paddingBottom:'10px',
            opacity:'100%'
        },
        button:{
            backgroundColor:'#4b1c37',
            borderRadius:'0px',
            borderColor:'#4b1c37',
        },
        buttonHeader:{
            borderRadius:'0px',
            borderColor:'#4b1c37',
            width:'8vw'
        },
        formFields:{
            borderRadius:'5px',
            borderColor:'#c4c4c4',
            zIndex: 0,
        },
        dropdown:{
            borderRadius:'0px',
            borderColor:'#50505a',
            width:'100%'
        },
        dropdownHeader:{
            borderRadius:'0px',
            borderColor:'#4b1c37',
    
        }

    }
}